// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, doc, updateDoc, getDoc, query, where, deleteDoc, addDoc, limit, collection, getDocs, orderBy, startAfter } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, signInWithCredential } from "firebase/auth"; // Import getAuth from firebase/auth
import { getStorage, ref, getDownloadURL } from 'firebase/storage'; // Import getStorage for Firebase storage

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyByB797noTuFjRfMjaflvhOHypdniAFup4",
    authDomain: "loc-d-in-6cbd4.firebaseapp.com",
    databaseURL: "https://loc-d-in-6cbd4-default-rtdb.firebaseio.com",
    projectId: "loc-d-in-6cbd4",
    storageBucket: "loc-d-in-6cbd4.appspot.com",
    messagingSenderId: "119320279539",
    appId: "1:119320279539:web:531bb87b092961912d3a86",
    measurementId: "G-NQV98GTRE4"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app); // Initialize auth
const storage = getStorage(app); // Initialize storage

export {
    db,
    doc,
    auth,
    getDoc,
    deleteDoc,
    query,
    where,
    addDoc,
    limit,
    collection,
    getDocs,
    orderBy,
    startAfter,
    storage,
    ref,
    getDownloadURL,
    updateDoc,
    GoogleAuthProvider,
    signInWithCredential,
};

